import React, {PropsWithoutRef} from "react";

export const Layers = ({children}: PropsWithoutRef<any>) => {
    return <div>{children}</div>
}